module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c8GUY"))).then(() => parcelRequire('d0iPb'));